export const useRemToPx = (rem: number | string, base: number | string = 16) => {
	return parseInput(rem) * parseInput(base);
};

const parseInput = (input: number | string) => typeof input === 'string' ? Number.parseInt(input, 10) : input;
